import { Dimensions } from 'react-native';

const { width, height } = Dimensions.get('window');
/**
 * basically it checks if this iPhone SE or Samsung Nexus S for ex
 */
export const isSmallScreen = width <= 375 || height <= 667;
